import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import { faSortCircle as faSortCircleRegular } from '@icons/regular/faSortCircle';
import { faSortCircle as faSortCircleSolid } from '@icons/solid/faSortCircle';

import Overlay from '@components/Overlay.vue';
import { dateFilter } from '@filters/date';
import { modals } from '@modals';
import { Announcements } from '@store';

import NavDropdown from './NavDropdown.vue';

/**
 * `AnnouncementsDropdown` component properties.
 */
export interface Props {
  announcements: Announcements.UserAnnouncement[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementsDropdown',
  props: {
    announcements: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  announcements: Announcements.UserAnnouncement[];
};



// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
const dropdown = ref<InstanceType<typeof NavDropdown> | null>(null);

const sortByUnread = ref(false);

/** Announcement list items. */
const items = computed(() => {
  let announcements = sortBy(uniqBy(props.announcements, 'id'), [
    'createdAt',
  ]).reverse();

  if (sortByUnread.value) {
    announcements = sortBy(announcements, ['read']);
  }

  return announcements.map((o) => {
    const date = dateFilter(o.createdAt, 'MM/dd/yyyy') as string;
    const time = dateFilter(o.createdAt, 'h:mm') as string;
    const createdAt = `${date} at ${time}`;

    const message = generateMessagePreview(o.message);

    return { ...o, createdAt, message };
  });
});

const sortBtnIcon = computed(() => {
  return sortByUnread.value ? faSortCircleSolid : faSortCircleRegular;
});

const sortBtnTooltip = computed(() => {
  return sortByUnread.value ? 'Sort by date.' : 'Sort by unread.';
});

/**
 * ...
 */
function toggle() {
  dropdown?.value?.toggle();
}

expose({ toggle });

/**
 * Toggle sort mode.
 */
function toggleSortMode() {
  sortByUnread.value = !sortByUnread.value;
}

/**
 * View a specific announcement.
 *
 * @param announcement The announcement to display.
 */
function view(announcement: Announcements.UserAnnouncement) {
  close();

  void modals.announcement.view({ announcement });
}

//#region Helper Functions

/**
 * ...
 *
 * @param source ...
 * @return ...
 */
function generateMessagePreview(source: string) {
  const el = document.createElement('div');
  el.innerHTML = source;

  const preview = el.innerText;

  el.remove();

  return preview;
}

//#endregion Helper Functions

return { __sfc: true,props, dropdown, sortByUnread, items, sortBtnIcon, sortBtnTooltip, toggle, toggleSortMode, view, generateMessagePreview, Overlay, NavDropdown }
}

})